import "./index.css";

import { CampagneCreator } from "@/components/CampagneCreator";
import { CampagneDetail } from "@/components/CampagneDetail";
import { CampagneList } from "@/components/CampagneList";
import { ParcoursCreator } from "@/components/ParcoursCreator";
import { ParcoursDetail } from "@/components/ParcoursDetail";
import { ParcoursList } from "@/components/ParcoursList";
import { NotFound } from "@repo/ui";
import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";
import { AdminAuthGuard } from "./components/AdminAuthGuard";
import { EvaluationResults } from "./components/EvaluationResults";
import { LoginPage } from "./components/LoginPage";

const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    element: <AdminAuthGuard />,
    children: [
      {
        path: "/",
        element: <ParcoursList />,
      },
      {
        path: "/creer",
        element: <ParcoursCreator />,
      },
      {
        path: "/p/:id",
        element: <ParcoursDetail />,
      },
      {
        path: "/p/:parcoursId/evaluation/:evaluationId",
        element: <EvaluationResults />,
      },
      {
        path: "/campagnes",
        element: <CampagneList />,
      },
      {
        path: "/campagnes/:id",
        element: <CampagneDetail />,
      },
      {
        path: "/campagnes/creer",
        element: <CampagneCreator />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);

export function App() {
  return <RouterProvider router={router} />;
}

export default App;
